(function (Drupal) {
  'use strict';
  Drupal.behaviors.frontendImageGallery = {
    attach: function (context) {
      const bemBlock = 'paragraph-image-gallery';

      const previewEl = context.querySelector('.' + bemBlock + '__preview');
      const trackEl = context.querySelector('.' + bemBlock + '__track');
      if (!previewEl || !trackEl) {
        return;
      }

      const paragraph = {
        parent: '__content',
        wrapper: '__images',
        slide: '__images-item'
      };

      const previewSlides = previewEl.querySelectorAll('.' + bemBlock + paragraph['slide']);
      const previewWrapper = previewEl.querySelector('.' + bemBlock + paragraph['wrapper']);
      initSwiperClass(previewEl, previewWrapper, previewSlides);
      const trackSlides = trackEl.querySelectorAll('.' + bemBlock + paragraph['slide']);
      const trackWrapper = trackEl.querySelector('.' + bemBlock + paragraph['wrapper']);
      initSwiperClass(trackEl, trackWrapper, trackSlides);

      const previewSwiper = new Swiper(previewEl, {
        slidesPerView: 1,
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        allowTouchMove: true,
        watchOverflow: true,
        loop: true,
        speed: 300,
        autoplay: {
          delay: 2000
        }
      });

      const trackSwiper = new Swiper(trackEl, {
        slidesPerView: 6,
        slideToClickedSlide: true,
        watchOverflow: true,
        loop: false,
        speed: 300,
        allowTouchMove: true,
        spaceBetween: 10
      });

      trackSwiper.on('click', () => {
        previewSwiper.slideTo(trackSwiper.clickedIndex);
      });

      previewSwiper.on('slideChangeTransitionEnd', () => {
        trackSwiper.slideTo(previewSwiper.activeIndex);
      });
    }
  };

  function initSwiperClass(container, wrapper, slides) {
    container.classList.add('swiper-container');
    wrapper.classList.add('swiper-wrapper');
    slides.forEach((slide) => {
      slide.classList.add('swiper-slide');
    });
  }

})(Drupal, Swiper);

